"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Sidebar = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Sidebar, _React$Component);

  // establish type of sidebar reference
  function Sidebar(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "sidebarRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function (event) {
      var sidebarOffsetTop = _this.sidebarRef.current.offsetTop;

      _this.sidebarRef.current.setAttribute('data-debug-current-offset', sidebarOffsetTop);

      if (sidebarOffsetTop > 78) {
        _this.sidebarRef.current.setAttribute('style', 'max-height:calc(100vh - 75px);');
      } else {
        _this.sidebarRef.current.setAttribute('style', 'max-height:calc(100vh - 155px);');
      }
    });

    _this.sidebarRef = /*#__PURE__*/React.createRef();
    _this.state = {
      sidebarHeight: ''
    };
    return _this;
  }

  var _proto = Sidebar.prototype;

  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        open = _this$props.open,
        title = _this$props.title,
        body = _this$props.body;
    return /*#__PURE__*/React.createElement("div", {
      className: "grouped-personas__sidebar " + (open ? 'grouped-personas__sidebar--active' : '')
    }, /*#__PURE__*/React.createElement("div", {
      // styles of this div need to be manipulated when scrolling
      ref: this.sidebarRef,
      style: {
        maxHeight: this.state.sidebarHeight
      },
      className: "grouped-personas__sidebar-inner " + (open ? 'grouped-personas__sidebar-inner--active' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "grouped-personas__icon-container"
    }, title), /*#__PURE__*/React.createElement("div", {
      className: "grouped-personas__sidebar-content " + (open ? 'grouped-personas__sidebar-content--active' : '') + " "
    }, body)));
  };

  return Sidebar;
}(React.Component);

var _default = Sidebar;
exports["default"] = _default;